'use strict';

import {Component, Inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {AuthService, HeaderAction, HeaderMenuItem, HeaderMenuLink, HeaderMenuSeparator, LanguageLink} from 'ais-common';
import {Subscription} from 'rxjs';
import {AppService} from './app.service';
import {Info} from './model/info';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  username: string;
  infoDataSubscription: Subscription;
  languageLinks: LanguageLink[] = [];
  aisUrl: string;
  userLogged = true;

  loginSubscription: Subscription;
  logoutSubscription: Subscription;
  red = false;
  appName = 'Študent';
  headerMenuItems: HeaderMenuItem[] = [];
  headerMenuMobileItems: HeaderMenuItem[] = [];
  private zalozkySubscription: Subscription;
  private ucitel = false;
  showBanner = false;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private authService: AuthService,
    private appService: AppService,
    public translate: TranslateService,
    private router: Router
  ) {
    translate.use(locale);
  }

  ngOnInit(): void {

    this.translate.get('Student')
      .subscribe((appName) => {
        this.appName = appName;
      });

    this.infoDataSubscription = this.appService.infoData
      .subscribe((info: Info) => {

        if (!info.student) {
          window.location.href = '/ais/start.do';
        }

        this.ucitel = info.ucitel;

        this.appService.fetchZalozky();

        this.aisUrl = '/ais/portal/changeLocale.do?locale=' + this.locale.toUpperCase();
        this.username = info.fullName;
        this.languageLinks = [];
        this.red = (info.oj === 'UK');
        this.appService.setRed(this.red);
        info.languages.forEach(
          item => this.languageLinks.push(
            new LanguageLink('..\\' + item.toLowerCase(), item.toUpperCase())
          )
        );

        this.showBanner = info.baner;
      });

    this.zalozkySubscription = this.appService.zalozkySubject
      .subscribe((zalozky) => {
        this.headerMenuItems = [];
        this.headerMenuMobileItems = [];
        zalozky.forEach(zalozka => {

          this.headerMenuItems.push(
            new HeaderAction(zalozka.nazov, '/zalozka/' + zalozka.id, 'fiber_manual_record')
          );

          // zalozky pre mobilne zobrazenie
          if (zalozka.mobil === 'A') {
            this.headerMenuMobileItems.push(
                new HeaderAction(zalozka.nazov, '/zalozka/' + zalozka.id, 'fiber_manual_record')
            );
          }

        });

        if (this.ucitel) {
          this.headerMenuItems.push(new HeaderMenuSeparator());
          this.headerMenuItems.push(
            new HeaderMenuLink(
              this.translate.instant('Učiteľské zobrazenie'),
              '/ais/portal2/ucitel?lng=' + this.locale.toUpperCase(),
              'arrow_back'
            )
          );

          this.headerMenuMobileItems.push(new HeaderMenuSeparator());
          this.headerMenuMobileItems.push(
            new HeaderMenuLink(
              this.translate.instant('Učiteľské zobrazenie'),
              '/ais/portal2/ucitel?lng=' + this.locale.toUpperCase(),
              'arrow_back'
            )
          );

        }

        this.headerMenuItems.push(new HeaderMenuSeparator());
        this.headerMenuItems.push(
          new HeaderMenuLink(
            this.translate.instant('Univerzálne zobrazenie'),
            '/ais/portal/changeLocale.do?locale=' + this.locale.toUpperCase(),
            'arrow_back'
          )
        );

        this.headerMenuMobileItems.push(new HeaderMenuSeparator());
        this.headerMenuMobileItems.push(
          new HeaderMenuLink(
            this.translate.instant('Univerzálne zobrazenie'),
            '/ais/portal/changeLocale.do?locale=' + this.locale.toUpperCase(),
            'arrow_back'
          )
        );

      });

    this.loginSubscription = this.authService.login
      .subscribe(() => {
        this.userLogged = true;
      });

    this.logoutSubscription = this.authService.logout
      .subscribe(() => {
        this.userLogged = false;
      });

    this.authService.initAccessTokenSession();

    this.appService.startChangesCheck();

    this.appService.saveUserSettings();

  }

  ngOnDestroy(): void {
    this.infoDataSubscription.unsubscribe();
    this.loginSubscription.unsubscribe();
    this.logoutSubscription.unsubscribe();
    this.zalozkySubscription.unsubscribe();
  }

  onActivate() {
    window.scroll(0, 0);
  }

  notHome() {
    return this.router.url.split('?')[0] !== '/';
  }
}
